var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "700ui3pfka",
    width: "113.3%",
    height: "153.3%",
    x: "-6.6%",
    y: "-26.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.636224911 0 0 0 0 0.695195401 0 0 0 0 0.768908514 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H7846V8520H0z",
    transform: "translate(-4698 -7249)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#700ui3pfka)",
    transform: "translate(-4698 -7249) translate(4678 7180) translate(0 59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H181V45H0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z",
    transform: "translate(-4698 -7249) translate(4698 7249)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F26D7E",
    fillRule: "nonzero",
    d: "M21 13c0 4.42-3.582 8-8 8s-8-3.58-8-8c0-4.417 3.582-8 8-8s8 3.583 8 8zm-8 1.613c-.82 0-1.484.664-1.484 1.484S12.18 17.58 13 17.58s1.484-.665 1.484-1.484c0-.82-.664-1.484-1.484-1.484zm-1.409-5.334l.24 4.387c.01.206.18.366.386.366h1.566c.206 0 .375-.16.387-.366l.239-4.387c.012-.222-.165-.408-.387-.408h-2.044c-.222 0-.399.186-.387.408z",
    transform: "translate(-4698 -7249) translate(4698 7249)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastFailed);
export default __webpack_public_path__ + "static/media/toast-failed.376c71760ea9113f023cfeb3627dba08.svg";
export { ForwardRef as ReactComponent };